var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 11,
    cy: 32,
    rx: 10,
    ry: 1,
    fill: "#636363"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0353 28.941L10.0336 28.9388C8.54575 27.0674 6.1496 23.8664 4.12819 20.5022C3.11743 18.8201 2.20601 17.1064 1.54861 15.5042C0.887966 13.8941 0.5 12.4347 0.5 11.25C0.5 5.30221 5.21147 0.5 11 0.5C16.7863 0.5 21.5 5.30228 21.5 11.25C21.5 12.434 21.1092 13.8929 20.4445 15.5032C19.7832 17.1054 18.8669 18.8192 17.8528 20.5016C15.825 23.8658 13.4288 27.0671 11.9644 28.9415C11.4598 29.5828 10.5397 29.5827 10.0353 28.941ZM11 15.5C13.3091 15.5 15.1667 13.5838 15.1667 11.25C15.1667 8.91615 13.3091 7 11 7C8.69093 7 6.83333 8.91615 6.83333 11.25C6.83333 13.5838 8.69093 15.5 11 15.5Z",
    fill: "#0D5ADC",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointer);
export default __webpack_public_path__ + "static/media/map-pointer.da2105b732755d49d9c94a3f0747c5d8.svg";
export { ForwardRef as ReactComponent };